<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-26 15:34:46
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-26 17:49:02
-->
<template>
  <a-spin :spinning="loading">
    <div class="box">
        <div class="content">
          <div class="left">
            <div class="left-box">
                <div class="process">
              <div :style="{boxShadow:selectIndex=='kaishi'?'#a9b4cd  1px 1px 11px':''}" @click="start" class="start">
                <div class="start-txt">开始</div>
                <div class="item">
                  <div>设置发布人员</div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="line"></div>
              <div @click="addFirst" class="circle">
              <i class="ri-add-line icon-add"></i>
              </div>
              <div class="line"></div>
              <div v-for="(item, index) in processData" class="add-one">
                <div
                  @click="setUser(item, index)"
                  style="background: #ff8800"
                  :style="{boxShadow:selectIndex == index?'1px 1px 7px rgb(255, 136, 0)':''}"
                  class="start"
                >
                  <div class="start-txt">审核 {{index+1}}</div>
                  <div class="item">
                    <div>设置审核人员</div>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div @click.stop="deleteFnProcess(index)" :class="selectIndex==index?'deleteTwo':'delete'">
                    <i style="font-size:18px" class="ri-close-line"></i>
                  </div>
                </div>
                <div class="line"></div>
                <div @click="addOne(index)" class="circle">
                  <i class="ri-add-line icon-add"></i>
                </div>
                <div class="line"></div>
              </div>
              <div :style="{boxShadow:selectIndex=='jieshu'?'#a9b4cd  1px 1px 11px':''}" @click="end" class="start">
                <div class="start-txt">结束</div>
                <div class="item">
                  <div>其他设置</div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
                </div>
            </div>
          </div>
          <div :style="{height:`${heightTwo}px`}" class="right">
                <div class="right-box-cont" :style="{height:(heightTwo-80)+'px'}">
                    <div class="right-title">节点设置 - {{nodeName}}</div>
              <div class="title-box">
                <i class="el-icon-info icon-title"></i>
                <div v-if="selectType != 3">以下人员发布内容时将响应此工作流</div>
                <div v-if="selectType == 3">工作流的其他设置项</div>
              </div>
              <div v-if="selectType == 1" class="submit-box">
                  <div class="submit-title">谁可以提交</div>
                  <div class="rideo-box">
                    <el-radio @input="startInput" v-model="startRadio" label="1">指定管理员</el-radio>
                      <el-radio @input="startInput" v-model="startRadio" label="2">指定角色</el-radio>
                  </div>
                  <div style="padding: 0 14px">
                      <div class="dir-box"></div>
                  </div>
                  <div v-if="startRadio == '1'" class="btn-box">
                      <div class="submint-show-box">
                          <el-button size="medium" @click="admin" class="btn-change" type="primary">选择管理员</el-button>
                          <div style="margin-bottom:14px;margin-left:14px;color:#ccc" v-if="startIsSubmint">数据还未保存</div>
                      </div>
                      <div  class="admin-box" v-for="(item,index) in startData.properties.initiators">
                          <div class="admin-one">
                              <div>{{item.name}}  {{item.userPhone}}  {{item.userOrgName}}</div>
                              <i @click="deleteFnTwoOldStart(index,item.id)" class="ri-close-line close-icon"></i>
                          </div>
                      </div>
                      <div v-if="(startData.properties.initiators && startData.properties.initiators.length == 0)" class="emty">暂无人员</div>
                  </div>
                  <div  v-if="startRadio == '2'">
                        <a-tree
                            v-model="startCheckList"
                            checkable
                            :expanded-keys="startCheckList"
                            :auto-expand-parent="true"
                            :tree-data="rolesData"
                            @check="changeCheack"
                          />
                  </div>
                    
                </div>
              <div v-if="selectType == 2" class="submit-box">
                  <div class="submit-title">谁可以审核</div>
                  <div class="rideo-box">
                    <el-radio v-model="contRadio[selectIndex]" label="1">指定管理员</el-radio>
                      <el-radio v-model="contRadio[selectIndex]" label="2">指定角色</el-radio>
                  </div>
                  <div style="padding: 0 14px">
                      <div class="dir-box"></div>
                  </div>
                  <div v-if="contRadio[selectIndex] == '1'" class="btn-box">
                      <div class="submint-show-box">
                          <el-button size="medium" @click="admin" class="btn-change" type="primary">选择管理员</el-button>
                          <div style="margin-bottom:14px;margin-left:14px;color:#ccc" v-if="contIsSubmint[selectIndex]">数据还未保存</div>
                      </div>
                      <div   class="admin-box" v-for="(item,index) in processData[selectIndex] && processData[selectIndex].properties.member">
                          <div class="admin-one">
                              <div>{{item.userName}}  {{item.userPhone}}  {{item.userOrgName}}</div>
                              <i @click="deleteFnTwoOld(index,item.id)" class="ri-close-line close-icon"></i>
                          </div>
                      </div>
                      <div v-if="(processData[selectIndex] &&  processData[selectIndex].properties &&  processData[selectIndex].properties.member && processData[selectIndex].properties.member.length == 0)" class="emty">暂无人员</div>
                  </div>
                    <div class="check-box" v-if="contRadio[selectIndex] == '2'">
                        <a-tree
                            v-model="checkListTwo[selectIndex]"
                            checkable
                            :expanded-keys="checkListTwo[selectIndex]"
                            :auto-expand-parent="true"
                            :tree-data="rolesData"
                            @check="changeCheackTwo"
                          />
                      </div>
                </div>
              
                <div v-if="selectType == 2" class="submit-box">
                  <div class="submit-title">审核方式</div>
                      <div style="margin-left:14px">
                          <div style="margin-top:14px"> <el-radio @input="reviewWayTypeFan" v-model="processData[selectIndex].properties.reviewWay" label="1" >允许由提交人代为审核</el-radio></div>
                          <div style="margin-top:14px;margin-bottom:14px"><el-radio  @input="reviewWayTypeFan" v-model="processData[selectIndex].properties.reviewWay" label="2">仅允许审核人员本人操作</el-radio></div>
                      </div>
                    </div>
                    <div v-if="selectType == 2" class="submit-box">
                  <div class="submit-title">审核人为空时指定审核人员</div>
                      <div class="btn-box">
                     
                      <div class="submint-show-box">
                           <el-button style="margin-top:20px" size="medium" @click="adminTwo" class="btn-change" type="primary">选择管理员</el-button>
                          <div style="margin-left:14px;color:#ccc" v-if="contIsSubmintTwo[selectIndex]">数据还未保存</div>
                      </div>
                      <div class="admin-box" v-for="(item,index) in processData[selectIndex] && processData[selectIndex].properties.adminMember">
                          <div class="admin-one">
                              <div>{{item.userName}}  {{item.userPhone}}  {{item.userOrgName}}</div>
                              <i @click="deleteFnTwoOldTwo(index,item.id)" class="ri-close-line close-icon"></i>
                          </div>
                      </div>
                      <div v-if="processData[selectIndex] && processData[selectIndex].properties.adminMember.length == 0" class="emty">暂无人员</div>
                  </div>
                    </div>
                    <div v-if="selectType == 3" class="submit-box">
                  <div class="submit-title">审核结束后是否自动发布</div>
                      <div style="margin-left:14px">
                          <div style="margin-top:14px"> <el-radio @input="rideoInput" v-model="endType" label="1" >终审通过后自动发布</el-radio></div>
                          <div style="margin-top:14px;margin-bottom:14px"><el-radio @input="rideoInput" v-model="endType" label="2">终审通过后需手动发布</el-radio></div>
                      </div>
                    </div>
                </div>
                
                <el-button :loading="loadingTwo" @click="submintData" class="btn-box-two" size="medium"  type="primary">保存</el-button>
          </div>
        </div>
        <el-dialog
        title="选择管理员"
        :visible.sync="isAdmin"
        width="1000px"
        top="17%"
        :before-close="closeTwo"
      >
      <a-spin :spinning="listShowLoading">
        <div class="org-box">
          <div class="org-left">
            <a-input v-model="name" placeholder="搜索管理员姓名">
              <a-tooltip slot="prefix">
                <span  @click="onSearch" class="icon-search-1"></span>
              </a-tooltip>
            </a-input>
            <a-table
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              :columns="columns"
              :scroll="{y: 400 }"
              :data-source="data"
              rowKey="id"
              :pagination="false"
              class="talbe-style"
            />
            <div class="pagination" v-if="pagination.total > 0">
                <a-pagination
                  size="small"
                  :current="pagination.current"
                  :pageSize="pagination.pageSize"
                  :total="pagination.total"
                  @change="onShowSizeChange"
                  @showSizeChange="handleSizeChange"
                  :page-size-options="pagination.pageSizeOptions"
                />
            </div>
          </div>
          <div class="org-right">
              <div class="select-number">
                <div class="number">已选{{selectUser.length}}管理员</div>
                <a @click="clearTwo" class="number">清空</a>
              </div>
              <div v-for="(item,index) in selectUser" class="one">
                  <div class="name"><div class="name-box"><span :title="`${item.name || item.userName} ${item.phone || item.userPhone} ${item.organizationName ||  item.userOrgName}`">{{item.name || item.userName}}  {{item.phone || item.userPhone}}  {{item.organizationName ||  item.userOrgName}}</span></div></div>
                  <span @click="deleteFnTwo(index,item.id)" class="icon-close"></span>
                </div>
          </div>
        </div>
        <div class="btn">
              <a-button @click="closeTwo">取消</a-button>
              <a-button @click="submitTwo" style="margin-left:14px" type="primary">确定</a-button>
    
        </div>
        </a-spin>
      </el-dialog>
      <el-dialog
        title="选择管理员"
        :visible.sync="isAdminTwo"
        width="1000px"
        top="17%"
        :before-close="closeTwoTwo"
      >
       <a-spin :spinning="listShowLoading">
        <div class="org-box">
          <div class="org-left">
            <a-input v-model="nameTwo" placeholder="搜索管理员姓名">
              <a-tooltip slot="prefix">
                <span  @click="onSearchTwo" class="icon-search-1"></span>
              </a-tooltip>
            </a-input>
            <a-table
              :row-selection="{ selectedRowKeys: selectedRowKeysTwo, onChange: onSelectChangeTwo }"
              :columns="columns"
              :scroll="{y: 400 }"
              :data-source="data"
              rowKey="id"
              :pagination="false"
              class="talbe-style"
            />
            <div class="pagination" v-if="pagination.total > 0">
                <a-pagination
                  size="small"
                  :current="pagination.current"
                  :pageSize="pagination.pageSize"
                  :total="pagination.total"
                  @change="onShowSizeChange"
                  @showSizeChange="handleSizeChange"
                  :page-size-options="pagination.pageSizeOptions"
                />
            </div>
          </div>
          <div class="org-right">
              <div class="select-number">
                <div class="number">已选{{selectUserTwo.length}}管理员</div>
                <a @click="clearTwoTwo" class="number">清空</a>
              </div>
              <div v-for="(item,index) in selectUserTwo" class="one">
                  <div class="name"><div class="name-box"><span :title="`${item.name || item.userName} ${item.phone || item.userPhone} ${item.organizationName ||  item.userOrgName}`">{{item.name || item.userName}}  {{item.phone || item.userPhone}}  {{item.organizationName ||  item.userOrgName}}</span></div></div>
                  <span @click="deleteFnTwoTwo(index,item.id)" class="icon-close icon-box"></span>
                </div>
          </div>
        </div>
        <div class="btn">
              <a-button @click="closeTwoTwo">取消</a-button>
              <a-button @click="submitTwoTwo" style="margin-left:14px" type="primary">确定</a-button>
    
        </div>
         </a-spin>
      </el-dialog>
    </div>
  </a-spin>
</template>

<script>
import { message } from "ant-design-vue";
import { details,listTwo,save,listRoles } from "./custom_variables";
export default {
  data() {
    return {
      processData: [],
      adminData:[],
      startRadio:'1',
      listShowLoading:false,
      contRadio:[],
      endData: {
        nodeType: "end",
        endReleaseType: "",
      },
      pagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      paginationTwo: {
        current: 1,
        pageSize: 5,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      selectType: 1,
      selectIndex: 'kaishi',
      isOrg: false,
      treeData: [],
      name: "",
      nameTwo: "",
      selectedKeys: [],
      listData: [],
      result: [],
      oldData: [],
      oldKes: [],
      isAdmin: false,
      isAdminTwo: false,
      selectedRowKeys: [],
      selectedRowKeysTwo: [],
      data: [],
      columns: [
        {
          title: "管理员姓名",
          dataIndex: "name",
          width: "120px",
          ellipsis: true,
        },
        {
          title: "登录手机号",
          dataIndex: "phone",
          ellipsis: true,
        },
        {
          title: "所属组织",
          dataIndex: "organizationName",
          ellipsis: true,
        },
      ],
      oldUser: [],
      selectUser: [],
      selectUserTwo: [],
      oldSelectUserTwo: [],
      OldSelectedRowKeysTwo: [],
      oldRowsKeys: [],
      isAdminTwo: false,
      array: [],
      loading: false,
      codeData: [],
      oldRowsKeysTwo:[],
      oldUserTwo:[],
      startData:{
        "nodeType": "start",
        "optionalRange": "role",
        "properties": {
                "initiators": []
            }
      },
      endType:'1',
      endData:{
            "nodeType": "end",
            "endReleaseType": "autoRelease"
      },
      startKeys:[],
      contKeys:[],
      contKeysTwo:[],
      //reviewWayType:[],
      checkList:[],
      checkListTwo:[],
      rolesData:[],
      startCheckList:[],
      startIsSubmint:true,
      contIsSubmint:[],
      contIsSubmintTwo:[],
      loading:false,
      nodeName:'开始',
      loadingTwo:false,
    };
  },
  props:['heightTwo','selectGroupItem'],
  mounted() {
    this.getDetails();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.getRolesList();
  },
  methods: {
    deleteOne(item,index){
        this.adminData.splice(index,1)
    },
    startInput(){

    },
    getRolesList(){
        listRoles({
          size:999999999,
          current:1,
        }).then((res)=>{
            if(res.code == 0){
              let options = JSON.stringify(res.data.records)
                        .replace(/roleName/g, "title")
                        .replace(/id/g, "key");
              this.rolesData = JSON.parse(JSON.stringify(JSON.parse(options)));;
            }
        })
    },
    changeCheack(val){
          let vaiData = [];
          for (let index = 0; index < this.rolesData.length; index++) {
            const element = this.rolesData[index];
            if(val.indexOf(element.key) != -1){
                vaiData.push(element)
            }
          }
          let array = [];
          for (let index = 0; index < vaiData.length; index++) {
            const element = vaiData[index];
            array.push({
              id:element.key,
              name:element.title,
              optionalRange:"role",
              userOrgName:element.organizationName,
            })
          }
          this.startData.properties.initiatorsRoles = array;
          this.startData.optionalRange = 'role';
    },
    changeCheackTwo(val){
       let vaiData = [];
          for (let index = 0; index < this.rolesData.length; index++) {
            const element = this.rolesData[index];
            if(val.indexOf(element.key) != -1){
                vaiData.push(element)
            }
          }
         let array = [];
          for (let index = 0; index < vaiData.length; index++) {
            const element = vaiData[index];
            array.push({
              id:element.key,
              userName:element.title,
              userOrgName:element.organizationName,
            })
          }
          this.processData[this.selectIndex].properties.memberTwo = array;
          console.log(this.selectIndex,'ssssss')
          this.processData[this.selectIndex].properties.optionalRange = 'role';
          this.processData = JSON.parse(JSON.stringify(this.processData))
    },
     deleteFnTwoOld(index,id){
      this.contKeys[this.selectIndex].splice(this.contKeys[this.selectIndex].indexOf(id),1);
      this.processData[this.selectIndex].properties.member.splice(index,1)
    },
    // 处理删除管理员
    deleteFnTwoOldStart(index,id){
       this.startKeys.splice(this.startKeys.indexOf(id),1);
       this.startData.properties.initiators.splice(index,1);
    },
     deleteFnTwoOldTwo(index,id){
        this.contKeysTwo[this.selectIndex].splice(this.contKeysTwo[this.selectIndex].indexOf(id),1);
        this.processData[this.selectIndex].properties.adminMember.splice(index,1)
    },
    // 处理开始节点数据
    startFn(){
        let startData = [];
            for (let index = 0; index < this.oldUser.length; index++) {
              const element = this.oldUser[index];
              startData.push({
                id:element.id,
                name:element.name || element.userName,
                optionalRange:'admin',
                userPhone:element.phone || element.userPhone,
                userOrgName:element.organizationName || element.userOrgName,
              })
            }
            this.startData.properties.initiators = startData;
            this.startData.optionalRange = 'admin'
    },
    
    // 处理中间流程的节点
    contFn(){
        let array = [];
        if(this.oldUser.length > 0){
            for (let index = 0; index < this.oldUser.length; index++) {
            const element = this.oldUser[index];
            array.push({
              id:element.id,
              userName:element.name || element.userName,
              userPhone:element.phone || element.userPhone,
              userOrgName:element.organizationName || element.userOrgName,
            })
            this.processData[this.selectIndex].properties.member =  array;
            this.processData[this.selectIndex].properties.optionalRange = 'admin';
          }
        }else{
            this.processData[this.selectIndex].properties.member =  array;
            this.processData[this.selectIndex].properties.optionalRange = 'admin';
        }
          
    },
     contFnTwo(){
          let array = [];
          if( this.oldUserTwo.length > 0){
              for (let index = 0; index < this.oldUserTwo.length; index++) {
                  const element = this.oldUserTwo[index];
                  array.push({
                    id:element.id,
                    userName:element.name || element.userName,
                    userPhone:element.phone || element.userPhone,
                    userOrgName:element.organizationName || element.userOrgName,
                  })
                  this.processData[this.selectIndex].properties.adminMember =  array;
                }
          }else{
              this.processData[this.selectIndex].properties.adminMember =  array;
          }
          
    },
    reviewWayTypeFan(){
         //this.processData[this.selectIndex].properties.reviewWay = this.reviewWayType[this.selectIndex] == 1?'userOperate':'userSubmit'
    },
     submitTwo(){
        this.oldUser = this.selectUser;
        console.log(this.selectType,'sssssss');
        if(this.selectType == 1){
              this.startKeys = this.selectedRowKeys;
              this.startFn()
        }else if(this.selectType == 2){
              this.contKeys[this.selectIndex] = this.selectedRowKeys;
              this.contFn();
      }
      this.isAdmin = false;
      this.startIsSubmint = true;
      this.contIsSubmint[this.selectIndex] = true;
    },
    submitTwoTwo(){
        this.oldUserTwo = this.selectUserTwo;
        this.contKeysTwo[this.selectIndex] = this.selectedRowKeysTwo;
        this.contFnTwo()
        this.isAdminTwo = false;
        this.contIsSubmintTwo[this.selectIndex] = true;
    },
     admin(){
        this.isAdmin = true;
        this.name = '';
        this.nameTwo = '';
        this.pagination.current = 1;
        if(this.selectType == 1){
             this.selectedRowKeys = this.startKeys;
             if(this.startData.optionalRange == 'admin'){
                this.selectUser = this.startData.properties.initiators || [];
             }else{
                this.selectUser = [];
             }
             
        }else if(this.selectType == 2){
              this.selectedRowKeys = this.contKeys[this.selectIndex] || [];
              if(this.processData[this.selectIndex].properties.optionalRange == 'admin'){
                this.selectUser = this.processData[this.selectIndex].properties.member || [];
              }else{
                this.selectUser = [];
              }
              
        }
        this.name = '';
        this.getListOne()
    },
    submintData(){
        this.loadingTwo = true;
        if(this.startData.properties.initiators.length == 0 && (!this.startData.properties.initiatorsRoles || this.startData.properties.initiatorsRoles.length == 0)){
                message.error('请填写开始节点谁可以提交人员');
                this.start()
                 this.loadingTwo = false;
                return;
          }
          // 验证是否有节点没有填完
          for (let index = 0; index < this.processData.length; index++) {
            const element = this.processData[index];
            if(element.properties.member.length == 0 && (!element.properties.memberTwo || element.properties.memberTwo.length == 0)){
                message.error('请填写审核'+ (index + 1) + '谁可以审人员');
                this.setUser(element,index)
                 this.loadingTwo = false;
                return;
            }
            if(element.properties.adminMember.length == 0){
                message.error('请填写审核'+ (index + 1) + '指定审核人员');
                this.setUser(element,index)
                 this.loadingTwo = false;
                return;
            }
          }
         if(this.startData.optionalRange == 'role'){
            this.startData.properties.initiators = this.startData.properties.initiatorsRoles || this.startData.properties.initiators;
         }
          delete  this.startData.properties.initiatorsRoles;
         for (let index = 0; index < this.processData.length; index++) {
            const element = this.processData[index];
            element.properties.reviewWay = element.properties.reviewWay == '1' ?'userSubmit':'userOperate'
            if(element.properties.optionalRange == 'role'){
                  element.properties.member = element.properties.memberTwo || element.properties.member;
            }
            delete element.properties.memberTwo;
         }
          let data = [this.startData,...this.processData,this.endData]
          save({listConfig:JSON.stringify({processData:data}),id:this.selectGroupItem.id}).then((res)=>{
              if(res.code == 0){
                  this.startIsSubmint = false;
                   message.success('流程保存成功');
                  this.getDetails()
              }
               this.loadingTwo = false;
          })
    },
     adminTwo(){
        this.isAdminTwo = true;
        this.name = '';
        this.nameTwo = '';
        this.pagination.current = 1;
        this.selectedRowKeysTwo = this.contKeysTwo[this.selectIndex] || [];
        this.selectUserTwo = this.processData[this.selectIndex].properties.adminMember || [];
        this.nameTwo = '';
        this.getListOne()
    },
     onSearch(){
      this.pagination.current = 1;
      this.getListOne()
    },
     onSearchTwo(){
      this.pagination.current = 1;
      this.getListOne()
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getListOne();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getListOne();
    },
    getListOne(){
      this.listShowLoading = true;
      listTwo({
          stations:sessionStorage.getItem('siteId'),
          current: this.pagination.current,
          size: this.pagination.pageSize,
          childrenType:2,
          value:this.name || this.nameTwo,
          type:1,
          organs:JSON.parse(sessionStorage.getItem('userInfo')).organizationId,
        }).then((res)=>{
            if(res.code == 0){
                this.data = res.data.records;
                this.pagination.current = res.data.current;
                this.pagination.total = res.data.total;
                this.listShowLoading = false;
            }
        })
    },
    
     closeTwo(){
        this.isAdmin = false;
    },
     closeTwoTwo(){
        this.isAdminTwo = false;
    },
    rideoInput(val){
        if(val == 1){
            this.endData.endReleaseType = 'autoRelease';
        }else{
          this.endData.endReleaseType = 'notAutoRelease';
        }
    },
     onSelectChange(selectedRowKeys,items) {
       let arrdata = JSON.parse(JSON.stringify(this.selectUser))
       arrdata.push(...items)
       this.selectedRowKeys = selectedRowKeys;
       let array = [];
       for (let index = 0; index < arrdata.length; index++) {
        const element = arrdata[index];
        if(this.selectedRowKeys.indexOf(element.id) != -1){
            array.push(element)
        }
       }
       var obj = {};
       array = array.reduce(function(item, next) {
          obj[next.id] ? '' : obj[next.id] = true && item.push(next);
          return item;
          }, []);
        this.selectUser = array;
    },
    onSelectChangeTwo(selectedRowKeys,items) {
       let arrdata = JSON.parse(JSON.stringify(this.selectUserTwo))
       arrdata.push(...items)
       this.selectedRowKeysTwo = selectedRowKeys;
       let array = [];
       for (let index = 0; index < arrdata.length; index++) {
        const element = arrdata[index];
        if(this.selectedRowKeysTwo.indexOf(element.id) != -1){
            array.push(element)
        }
       }
       var obj = {};
       array = array.reduce(function(item, next) {
          obj[next.id] ? '' : obj[next.id] = true && item.push(next);
          return item;
          }, []);
        this.selectUserTwo = array;
    },
     deleteFnTwo(index,id){
      let array = JSON.parse(JSON.stringify(this.selectedRowKeys))
      array.splice(this.selectedRowKeys.indexOf(id),1);
      this.selectedRowKeys = JSON.parse(JSON.stringify(array))
      let arrayTwo = JSON.parse(JSON.stringify(this.selectUser))
      arrayTwo.splice(index,1)
      this.selectUser = arrayTwo;
    },
     deleteFnTwoTwo(index,id){
      let array = JSON.parse(JSON.stringify(this.selectedRowKeysTwo))
      array.splice(this.selectedRowKeysTwo.indexOf(id),1);
      this.selectedRowKeysTwo = JSON.parse(JSON.stringify(array))
      let arrayTwo = JSON.parse(JSON.stringify(this.selectUserTwo))
      arrayTwo.splice(index,1)
      this.selectUserTwo = arrayTwo;
    },
    getDetails() {
      this.loading = true;
      this.processData = [];
      details({
        id: this.selectGroupItem.id,
      }).then((res) => {
        let arrayData = JSON.parse(res.data.listConfig);
        if (!arrayData) {
          this.processData = [
              {
                nodeType: "approver",
                properties: {
                  member: [],
                  reviewWay: '1',
                  adminMember:[],
                  optionalRange:'admin',
                },
              },
            ];
            this.startData = {
              "nodeType": "start",
              "optionalRange": "admin",
              "properties": {
                      "initiators": []
                  }
            };
            this.endData = {
              nodeType: "end",
              endReleaseType: "",
           };
           this.contRadio[0] = '1';
        } else {
           for (let index = 0; index < arrayData.processData.length; index++) {
            const element = arrayData.processData[index];
            if(element.nodeType == 'start'){
                this.startData = element;
                let arrayKeys = [];
                let arrayChecks = [];
                for (let indexTwo = 0; indexTwo < element.properties.initiators.length; indexTwo++) {
                  const elementTwo = element.properties.initiators[indexTwo];
                  if(elementTwo.optionalRange == 'role'){
                      arrayChecks.push(elementTwo.id)
                  }else{
                     arrayKeys.push(elementTwo.id)
                  }
                }
                if(element.optionalRange == 'role'){
                    this.startRadio = '2'
                    element.properties.initiatorsRoles = element.properties.initiators;
                    element.properties.initiators = [];
                }
                this.startKeys = arrayKeys;
                setTimeout(()=>{
                   this.startCheckList = arrayChecks;
                },500)
            }else if(element.nodeType == 'approver'){
               let arrayThree = [];
                this.contIsSubmint[index-1] = false;
                this.contIsSubmintTwo[index-1] = false;
                if(element.properties.optionalRange == 'role'){
                    for (let index = 0; index < element.properties.member.length; index++) {
                      const elementThree = element.properties.member[index];
                      arrayThree.push(elementThree.id)
                    }
                    this.contRadio[index-1] = '2';
                    element.properties.memberTwo =  element.properties.member;
                    element.properties.member = [];
                }else{
                  this.contRadio[index-1] = '1';
                }
                 setTimeout(()=>{
                   this.checkListTwo[index-1] = arrayThree;
                },500)
                element.properties.reviewWay = element.properties.reviewWay == "userSubmit"?'1':'2';
                this.processData.push(element)
            }else{
                this.endType =  element.endReleaseType == 'notAutoRelease'?'2':'1';
                this.endData = element;
            }
           }
        }
        this.startIsSubmint = false;
        this.loading = false;
      });
    },
    addFirst() {
      this.processData.unshift({
        nodeType: "approver",
        properties: {
          member:[],
          adminMember:[],
          reviewWay: '1',
          optionalRange:'admin',
        },
      });
      this.setUser(this.processData[0],0)
    },
    clearTwo(){
      this.selectedRowKeys = [];
      this.selectUser = [];
    },
     clearTwoTwo(){
      this.selectedRowKeysTwo = [];
      this.selectUserTwo = [];
    },
    addOne(index) {
      this.processData.splice(index + 1, 0, {
        nodeType: "approver",
        properties: {
          member:[],
          adminMember:[],
          optionalRange:'admin',
          reviewWay: '1',
        },
      });
      this.setUser(this.processData[index + 1],index + 1)
    },
   
    deleteFnProcess(index) {
      if (this.processData.length == 1) {
        message.error("需要保留一个工作流");
        return;
      }
      this.processData.splice(index, 1);
      this.checkListTwo.splice(index, 1);
      this.contIsSubmint.splice(index,1);
      this.contRadio.splice(index,1);
      if(index == 0){
          this.setUser(this.processData[0],0);
      }else{
        this.setUser(this.processData[index-1],index-1);
      }
      
    },
    
    setUser(item, index) {
      this.selectType = 2;
      this.selectIndex = index;
      let arrayKeys = [];
      let checkList = [];
      this.contKeys[this.selectIndex] = [];
      this.contKeysTwo[this.selectIndex] = [];
      this.checkListTwo[this.selectIndex] = [];
      for (let index = 0; index < item.properties.member.length; index++) {
            const element = item.properties.member[index];
            arrayKeys.push(element.id)
      }
      this.contKeys[this.selectIndex] = arrayKeys;
      if(item.properties.memberTwo){
        for (let index = 0; index < item.properties.memberTwo.length; index++) {
          const element = item.properties.memberTwo[index];
          checkList.push(element.id)
       }
      }
      this.checkListTwo[this.selectIndex] = checkList;
      let arrayKeysTwo = [];
      for (let index = 0; index < item.properties.adminMember.length; index++) {
        const element = item.properties.adminMember[index];
        arrayKeysTwo.push(element.id)
      }
       this.contKeysTwo[this.selectIndex] = arrayKeysTwo;
       this.selectUser = item.properties.member || [];
       this.selectUserTwo = item.properties.adminMember || [];
       this.radio = '1';
       this.nodeName = "审核" + (index + 1);
       if(item.properties.optionalRange == 'role'){
            this.contRadio[index] = '2';
       }else{
          this.contRadio[index] = '1';
       }
    },
     start() {
      this.selectType = 1;
      this.nodeName = "开始"
      this.selectIndex = 'kaishi'
    },
     end() {
      this.selectType = 3;
      this.nodeName = "结束"
      this.selectIndex = 'jieshu'
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  height: 100%;
}
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    display: flex;
    align-items: center;
    .title {
      font-size: 12px;
      color: #ccc;
    }
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
}
.content {
  display: flex;
  position: relative;
  .left {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    height: calc(77.2vh);
    margin-right: 60px;
    .start {
      background: #a9b4cd;
      border-radius: 6px;
      width: 180px;
      height: 65px;
      padding: 5px;
      margin: auto;
      padding-top: 0px;
      position: relative;
      .start-txt {
        font-size: 12px;
        color: #fff;
        margin-left: 5px;
      }
      .item {
        background: #fff;
        border-radius: 4px;
        height: 36px;
        line-height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 12px;
        padding-right: 12px;
        margin-top: 5px;
        color: #000;
        /deep/ .el-icon-arrow-right {
          color: #000;
          font-weight: 600;
          font-size: 12px;
        }
      }
    }
  }
  .right {
    width: 500px;
    height: 768px;
    line-height: 20px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    padding: 0 20px;
    overflow-y: auto;
    position: relative;
  }
  .line {
    height: 34px;
    width: 2px;
    background: #d1d3d9;
    margin: auto;
  }
  .circle {
    width: 24px;
    height: 24px;
    border: 4px solid #c1d6ff;
    border-radius: 24px;
    margin: auto;
    text-align: center;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .icon-plus:before {
      color: #3377ff;
    }
    cursor: pointer;
  }
}
.process {
  margin-top: 40px;
  padding-bottom: 80px;
}
.pasword {
  cursor: pointer;
}
.add-one {
  cursor: pointer;
}
.input-box {
  //   margin-top: 10px;
}
.ruleForm {
  display: flex;
  justify-content: center;
  /deep/ .el-form-item {
    display: flex;
  }
  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
  /deep/ .el-form-item__label {
    text-align: left;
  }
  /deep/ .el-form-item:last-child {
    .el-form-item__label {
      width: 74px !important;
    }
  }
}
.title-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f4f4f5;
  padding: 5px 20px;
  padding-right: 10px;
  font-size: 12px;
  color: #909399;
  margin-bottom: 24px;
  border-radius: 4px;
  //   margin-top: 10px;
  .icon {
    display: flex;
    align-items: center;
  }
  .icon-info {
    margin-right: 10px;
  }
  /deep/ .icon-info:before {
    color: #a9aab1;
  }
  /deep/ .icon-close:before {
    font-size: 16px;
    color: #b2b3ba;
    cursor: pointer;
  }
}
.start {
  cursor: pointer;
}
.start:hover {
  .delete {
    display: block;
  }
}
.organization {
  border: solid 1px #eeeff2;
  border-radius: 4px;
  padding-bottom: 12px;
  min-height: 200px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 5px 0px;
    background: #f5f6f7;
    padding-left: 12px;
    padding-right: 12px;
    color: #000;
    font-weight: 600;
  }
  .one {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    padding-left: 12px;
    padding-right: 12px;
    color: #000;
  }
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
.org-box {
  height: 500px;
  border-radius: 4px;
  border: solid 1px #e0e3e9;
  display: flex;
  .org-left {
    border-right: solid 1px #e0e3e9;
    position: relative;
    flex: 1;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
  }
  .org-right {
    height: 100%;
    width: 427px;
    overflow-y: auto;
    .select-number {
      display: flex;
      justify-content: space-between;
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 24px;
      .number {
        font-weight: 500;
      }
    }
    .one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 12px;
      padding-left: 12px;
      padding-right: 12px;
      .name {
        font-weight: 500;
        color: #000;
        .name-box{
          width: 360px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.icon-close {
  cursor: pointer;
}
.btn {
  margin-top: 24px;
  text-align: right;
}
.talbe-style {
  margin-top: 24px;
  /deep/ .ant-table-tbody > tr.ant-table-row-selected td {
    background: #fff;
  }
}
.emty {
  margin-top: 10px;
  text-align: center;
  margin-bottom: 20px;
}
.delete {
  position: absolute;
  right: 3px;
  top: -2px;
  display: none;
}
.deleteTwo {
  position: absolute;
  right: 3px;
  top: -2px;
}
.start {
  .icon-close:before {
    color: #fff;
  }
}
/deep/ .icon-close:before {
  position: relative;
  cursor: pointer;
  width: 12px;
  height: 12px;
  z-index: 1;
}
.pagination {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 20px;
  width: calc(100% - 40px);
  text-align: center;
}
.icon-search-1 {
  cursor: pointer;
}
.left-box{
  display: flex;
  justify-content: center;
}
.icon-add{
  
  font-size: 20px;
  font-weight: 600;

}
.icon-add:before{
  color: rgba(51, 119, 255, 1);
}
.right-title{
  height: 50px;
  line-height: 20px;
  border-radius: 10px 10px 0px 0px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border-bottom: 1px solid rgba(228, 231, 237, 1);
  color: rgba(48, 49, 51, 1);
  font-size: 16px;
  text-align: left;
  font-family: Roboto-black;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 7px 0px;
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-top: 20px;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 4px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.submit-box{
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: 20px;
}
.submit-title{
  height: 36px;
  line-height: 20px;
  border-radius: 3px 3px 0px 0px;
  background-color: rgba(241, 243, 245, 1);
  line-height: 36px;
  display: flex;
  justify-content: flex-start;
  text-indent: 11px;
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
.rideo-box{
  padding: 17px 14px;
}
.dir-box{
  height:  1px;
 background:  rgba(220, 223, 230, 1);
 margin-bottom: 14px;
}
.btn-box{
    .btn-change{
        margin-left: 14px;
        margin-bottom: 14px;
    }
}
.el-button--primary {
  background: #176de6;
}
.admin-box{
  padding: 0px 14px;
  margin-bottom: 10px;
}
.admin-one{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(48, 49, 51, 1);
  .close-icon{
    font-size: 20px;
    color: rgba(102, 111, 128, 1);
    cursor: pointer;
  }
}
 /deep/ .ant-btn-primary{
      margin-bottom: 24px;
    }
    .right-box-cont{
      overflow-y: auto;
      margin-bottom: 20px;
      padding-bottom: 20px;
    }
    .btn-box-two{
       
    }
    ::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
/deep/ .ant-tree li span.ant-tree-switcher{
  width: 13px;
}
/deep/ .ant-tree{
  margin-top: -14px;
}
.submint-show-box{
  display: flex;
  align-items: center;
}
/deep/ .ant-btn-primary {
  background: #176de6;
}
</style>
